import {useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronDownIcon, ConnectorEndIcon, ConnectorMiddleIcon, ListIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {NavigationAmplitudeSource, NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";

import {INavigationSection} from "../config/navigation_sections";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";
import {
    navigationChevronClosedStyle,
    navigationChevronOpenStyle,
    navigationItemActiveStyle,
    navigationItemHoverStyle
} from "../constants/navigation_shared_styles";
import {useTrackNavigationSection} from "../hooks/use_track_navigation_section";
import {useNavigationSections} from "../hooks/useNavigationSections";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";

export const OffersNavGroup = () => {
    const [isExpanded, setIsExpanded] = useState(true);

    const {activeSection, sections} = useNavigationSections();
    const trackSection = useTrackNavigationSection(NavigationAmplitudeSource.DESKTOP_SIDEBAR);

    const handleToggleClick = () => {
        if (!isExpanded) NavigationAmplitudeTracker.expandMenuSection();
        setIsExpanded((expanded) => !expanded);
    };

    return (
        <div data-testid={KM_COMMON_TEST_IDS.NAV_LINKS}>
            <Button
                aria-expanded={isExpanded}
                className={cx(groupToggleStyle, !isExpanded && groupToggleCollapsedStyle)}
                iconLeft={ListIcon}
                iconRight={ChevronDownIcon}
                iconRightProps={{
                    className: cx(isExpanded ? navigationChevronOpenStyle : navigationChevronClosedStyle, chevronPositionStyle),
                    size: "1.5",
                    wrapperColor: "transparent",
                    wrapperSize: "1.6"
                }}
                onClick={handleToggleClick}
                size="small"
                textVariant="info_txt_1"
                type="button"
                variant="none_secondary"
            >
                {NAVIGATION_LABELS.SECTION_GROUP.DESKTOP}
            </Button>

            <div
                aria-hidden={!isExpanded}
                className={cx(subLinksCollapseStyle, isExpanded ? subLinksExpandedStyle : subLinksCollapsedStyle)}
                inert={!isExpanded || undefined}
            >
                <div className={subLinksInnerStyle}>
                    {sections.map((section, index) => (
                        <OffersNavGroupItem
                            isActive={activeSection?.view === section.view}
                            isLast={index === sections.length - 1}
                            key={section.view}
                            onNavigate={() => trackSection(section)}
                            section={section}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

interface IOffersNavGroupItemProps {
    isActive: boolean;
    isLast: boolean;
    onNavigate: () => void;
    section: INavigationSection;
}

const OffersNavGroupItem = (props: IOffersNavGroupItemProps) => {
    const {isActive, isLast, onNavigate, section} = props;

    const ConnectorIcon = isLast ? ConnectorEndIcon : ConnectorMiddleIcon;

    return (
        <NavigationLinkItem
            className={cx(subLinkRowStyle, navigationItemHoverStyle, isActive && navigationItemActiveStyle, navigationLinkItemResetStyle)}
            dataTestId={section.testIds.sidebar}
            onNavigate={onNavigate}
            to={section.path}
        >
            <ConnectorIcon className={connectorIconStyle} fill="var(--colors-gray-300)" />
            <Text className={cx(subLinkLabelStyle, isActive && subLinkActiveTextStyle)} variant="info_txt_1">
                {section.labels.sidebar}
            </Text>
        </NavigationLinkItem>
    );
};

const groupToggleStyle = css({
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    height: "4.8rem",
    justifyContent: "flex-start",
    p: 1.5,
    transition:
        "background-color var(--transition-duration) var(--transition-timingFunction), color var(--transition-duration) var(--transition-timingFunction), fill var(--transition-duration) var(--transition-timingFunction), border-color var(--transition-duration) var(--transition-timingFunction)",
    width: "100%",

    _hover: {
        backgroundColor: "var(--colors-background-50)",
        color: "var(--colors-secondary)",
        fill: "var(--colors-secondary)"
    },

    "& > span": {
        width: "100%"
    }
});

const groupToggleCollapsedStyle = css({
    borderColor: "transparent"
});

const chevronPositionStyle = css({
    ml: "auto"
});

const subLinksCollapseStyle = css({
    display: "grid",
    transition: "grid-template-rows var(--transition-duration-fast) var(--transition-timingFunction)"
});

const subLinksExpandedStyle = css({
    gridTemplateRows: "1fr"
});

const subLinksCollapsedStyle = css({
    gridTemplateRows: "0fr"
});

const subLinksInnerStyle = css({
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    pt: 2
});

const subLinkRowStyle = css({
    alignItems: "stretch",
    borderRadius: 1,
    display: "flex",
    pl: 1,
    transition: "background-color var(--transition-duration-fast) var(--transition-timingFunction)",
    width: "100%"
});

const connectorIconStyle = css({
    flexShrink: 0,
    height: "3.6rem",
    transform: "none",
    width: "2.4rem"
});

const subLinkLabelStyle = css({
    alignItems: "center",
    display: "flex",
    flex: 1,
    px: 1.5,
    py: "1rem"
});

const subLinkActiveTextStyle = css({
    fontWeight: 500
});
import {useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronDownIcon, ConnectorEndIcon, ConnectorMiddleIcon, ListIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {NavigationAmplitudeSource, NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";

import {INavigationSection} from "../config/navigation_sections";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";
import {
    navigationChevronClosedStyle,
    navigationChevronOpenStyle,
    navigationItemActiveStyle,
    navigationItemHoverStyle
} from "../constants/navigation_shared_styles";
import {useTrackNavigationSection} from "../hooks/use_track_navigation_section";
import {useNavigationSections} from "../hooks/useNavigationSections";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";

export const OffersNavGroup = () => {
    const [isExpanded, setIsExpanded] = useState(true);

    const {activeSection, sections} = useNavigationSections();
    const trackSection = useTrackNavigationSection(NavigationAmplitudeSource.DESKTOP_SIDEBAR);

    const handleToggleClick = () => {
        if (!isExpanded) NavigationAmplitudeTracker.expandMenuSection();
        setIsExpanded((expanded) => !expanded);
    };

    return (
        <div data-testid={KM_COMMON_TEST_IDS.NAV_LINKS}>
            <Button
                aria-expanded={isExpanded}
                className={cx(groupToggleStyle, !isExpanded && groupToggleCollapsedStyle)}
                iconLeft={ListIcon}
                iconRight={ChevronDownIcon}
                iconRightProps={{
                    className: cx(isExpanded ? navigationChevronOpenStyle : navigationChevronClosedStyle, chevronPositionStyle),
                    size: "1.5",
                    wrapperColor: "transparent",
                    wrapperSize: "1.6"
                }}
                onClick={handleToggleClick}
                size="small"
                textVariant="info_txt_1"
                type="button"
                variant="none_secondary"
            >
                {NAVIGATION_LABELS.SECTION_GROUP.DESKTOP}
            </Button>

            <div
                aria-hidden={!isExpanded}
                className={cx(subLinksCollapseStyle, isExpanded ? subLinksExpandedStyle : subLinksCollapsedStyle)}
                inert={!isExpanded || undefined}
            >
                <div className={subLinksInnerStyle}>
                    {sections.map((section, index) => (
                        <OffersNavGroupItem
                            isActive={activeSection?.view === section.view}
                            isLast={index === sections.length - 1}
                            key={section.view}
                            onNavigate={() => trackSection(section)}
                            section={section}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

interface IOffersNavGroupItemProps {
    isActive: boolean;
    isLast: boolean;
    onNavigate: () => void;
    section: INavigationSection;
}

const OffersNavGroupItem = (props: IOffersNavGroupItemProps) => {
    const {isActive, isLast, onNavigate, section} = props;

    const ConnectorIcon = isLast ? ConnectorEndIcon : ConnectorMiddleIcon;

    return (
        <NavigationLinkItem
            className={cx(subLinkRowStyle, navigationItemHoverStyle, isActive && navigationItemActiveStyle, navigationLinkItemResetStyle)}
            dataTestId={section.testIds.sidebar}
            onNavigate={onNavigate}
            to={section.path}
        >
            <ConnectorIcon className={connectorIconStyle} fill="var(--colors-gray-300)" />
            <Text className={cx(subLinkLabelStyle, isActive && subLinkActiveTextStyle)} variant="info_txt_1">
                {section.labels.sidebar}
            </Text>
        </NavigationLinkItem>
    );
};

const groupToggleStyle = css({
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    height: "4.8rem",
    justifyContent: "flex-start",
    p: 1.5,
    transition:
        "background-color var(--transition-duration) var(--transition-timingFunction), color var(--transition-duration) var(--transition-timingFunction), fill var(--transition-duration) var(--transition-timingFunction), border-color var(--transition-duration) var(--transition-timingFunction)",
    width: "100%",

    _hover: {
        backgroundColor: "var(--colors-background-50)",
        color: "var(--colors-secondary)",
        fill: "var(--colors-secondary)"
    },

    "& > span": {
        width: "100%"
    }
});

const groupToggleCollapsedStyle = css({
    borderColor: "transparent"
});

const chevronPositionStyle = css({
    ml: "auto"
});

const subLinksCollapseStyle = css({
    display: "grid",
    transition: "grid-template-rows var(--transition-duration-fast) var(--transition-timingFunction)"
});

const subLinksExpandedStyle = css({
    gridTemplateRows: "1fr"
});

const subLinksCollapsedStyle = css({
    gridTemplateRows: "0fr"
});

const subLinksInnerStyle = css({
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    pt: 2
});

const subLinkRowStyle = css({
    alignItems: "stretch",
    borderRadius: 1,
    display: "flex",
    pl: 1,
    transition: "background-color var(--transition-duration-fast) var(--transition-timingFunction)",
    width: "100%"
});

const connectorIconStyle = css({
    flexShrink: 0,
    height: "3.6rem",
    transform: "none",
    width: "2.4rem"
});

const subLinkLabelStyle = css({
    alignItems: "center",
    display: "flex",
    flex: 1,
    px: 1.5,
    py: "1rem"
});

const subLinkActiveTextStyle = css({
    fontWeight: 500
});
